import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

// Shared "showing X of Y · Load more" footer for the log pages.
export function LoadMore({ shownCount, total, hasMore, onMore, noun = "row", nounPlural, testid = "load-more" }) {
  if (total === 0) return null;
  const label = total === 1 ? noun : (nounPlural || `${noun}s`);
  return (
    <div className="flex items-center justify-between gap-3 mt-3 flex-wrap">
      <span data-testid={`${testid}-count`} className="text-xs text-slate-400">
        Showing {shownCount} of {total} {label}
      </span>
      {hasMore && (
        <Button data-testid={testid} variant="outline" size="sm" onClick={onMore}
          className="rounded-lg border-slate-300 h-8">
          <ChevronDown className="w-4 h-4 mr-1.5" />Load more
        </Button>
      )}
    </div>
  );
}
